import axios, {AxiosError} from "axios";
import * as Endpoints from './endpoints';
import * as RbacUtils from '../utils/rbac-utils';
import BaseService from "./base-service";

/**
 * Service for working with the SOML RBAC mapping.
 */
class SomlRbacService extends BaseService {

  /**
   * Gets the currently authenticated user's roles and role actions.
   *
   * @returns {Promise<Array<RbacRole>>}
   */
  static getUserRoles() {
    return axios.get(Endpoints.SOML_RBAC_ROLES)
      .then(this.resolveResponse)
      .then(RbacUtils.mapRoles)
      .catch((response: AxiosError) => {
        if (response.response?.status === 403) {
          // If the current user cannot even access the endpoint, it means no roles for
          // SOML management whatsoever
          return [];
        }
        return this.resolveErrorResponse(response);
      });
  }
}

export default SomlRbacService;
